import img from "../../../../assets/point-guide/step2_Meta_KOR2.png";
export default function Meta2() {
    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <img src={img} style={{ width: "100%", maxWidth: "800px", height: "auto", marginBottom: "-0.5px" }} alt={""} />
        </div>
    );
}
